<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Add New Asset User</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form
        [formGroup]="addAssetUserForm"
        (ngSubmit)="addAssetUserForm.valid && saveAssetUser()"
        novalidate
      >
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>EmployeeId</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter EmployeeId Max(20) chars"
                name="employeeId"
                id="employeeId"
                formControlName="employeeId"
                autocomplete="off"
                maxlength="20"
              />
              <mat-error
                *ngIf="addAssetUserForm.get('employeeId').hasError('required')"
              >
                EmployeeId is required.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('employeeId').hasError('maxlength')"
              >
                EmployeeId cannot be more than 20 characters.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('employeeId').hasError('pattern')"
              >
                EmployeeId must contain only letters and numbers, with no spaces
                in between.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>First Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter First Name Max(20) chars"
                name="firstName"
                id="firstName"
                formControlName="firstName"
                autocomplete="off"
                maxlength="20"
              />
              <mat-error
                *ngIf="addAssetUserForm.get('firstName').hasError('required')"
              >
                First Name is required.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('firstName').hasError('maxlength')"
              >
                First Name cannot be more than 20 characters.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('firstName').hasError('pattern')"
              >
                First Name must only contain letters, spaces, and period.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="Enter Last Name Max(20) chars"
                name="lastName"
                id="lastName"
                formControlName="lastName"
                maxlength="20"
              />
              <mat-error
                *ngIf="addAssetUserForm.get('lastName').hasError('required')"
              >
                Last Name is required.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('lastName').hasError('maxlength')"
              >
                Last Name cannot be more than 20 characters.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('lastName').hasError('pattern')"
              >
                Last Name must only contain letters, spaces, and period.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Email</mat-label>
              <input
                matInput
                type="email"
                formControlName="email"
                placeholder="Enter Email Max(50) chars"
                autocomplete="off"
              />
              <mat-error
                *ngIf="addAssetUserForm.get('email').hasError('required')"
              >
                Email is required.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('email').hasError('invalidEmail')"
              >
                {{ addAssetUserForm.get("email").getError("invalidEmail") }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Status</mat-label>
              <mat-select formControlName="appStatusId">
                <mat-option [value]="null">Select a status</mat-option>
                <mat-option
                  *ngFor="let status of userStatus"
                  [value]="status.appStatusId"
                >
                  {{ status.status }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="addAssetUserForm.get('appStatusId').hasError('required')"
              >
                Status is required.
              </mat-error>
            </mat-form-field>
          </div>
           <div class="col-12 col-sm-12 col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Mobile Number</mat-label>
              <input
                matInput
                type="text"
                required
                formControlName="mobileNumber"
                placeholder="Mobile Number Max(10) digits"
                maxlength="10"
                autocomplete="off"
              />
              <mat-error
                *ngIf="addAssetUserForm.get('mobileNumber').hasError('required')"
              >
                Mobile Number is required.
              </mat-error>
              <mat-error
                *ngIf="addAssetUserForm.get('mobileNumber').hasError('pattern')"
              >
                Mobile Number must be a 10-digit number.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="col-md-6">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="close()"
          >
            Close
          </button>
        </div>
        <div class="col-md-6">
          <button
            md-raised-button
            type="button"
            class="btn btn-round btn-block btn-rose"
            (click)="saveAssetUser()"
            [disabled]="!addAssetUserForm.valid"
          >
            Save
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
